import { ProductInterface } from '@pylot-data/pylotschema'
import { getStoreConfig } from 'config'

enum responseStatus {
    success = 200,
    ok = 'OK'
}
export type yotpoReviewData = {
    id: number
    score: number
    votes_up: number
    votes_down: number
    content: string
    title: string
    created_at: string
    deleted: boolean
    verified_buyer: boolean
    source_review_id: string
    sentiment: number
    custom_fields: string
    product_id: number
    user: {
        user_id: number
        social_image: null
        user_type: 'User'
        is_social_connected: number
        display_name: string
    }
}
export type YotpoReviewsApiResponse = {
    response: {
        bottomline: {
            average_score: number
            total_review: number
        }
        reviews: [yotpoReviewData]
    }
    status: {
        code: responseStatus.success
        message: responseStatus.ok
    }
}

export type YotpoReviewJsonLd = {
    product: ProductInterface
    review: any
}

export const yotpoReviewsJsonLd = ({ product, review }: YotpoReviewJsonLd) => {
    const config = getStoreConfig()
    if (
        !config.base.yotpo.enabled ||
        review?.status?.code !== responseStatus.success ||
        review?.status?.message !== responseStatus.ok
    ) {
        return product
    }

    const response = review?.response?.bottomline

    if (response?.total_review === 0) {
        //No review case
        return product
    }

    const reviews = review?.response?.reviews
    const productWithReview = { ...product } //clone object

    return {
        ...productWithReview,
        review_count: response?.total_review,
        review_summary: response?.average_score,
        yotpo_reviews: reviews
    }
}
